import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { isNotBlank } from '@fcom/core/utils';
import { CmsTeaser, CmsImageData, CmsMenuFoodItem } from '@fcom/core-api';
import { toKebabCase } from '@fcom/ui-components';

const DEFAULT_HEADER_LEVEL = 2;

@Component({
  selector: 'cms-teaser',
  templateUrl: './cms-teaser.component.html',
  styleUrls: ['./cms-teaser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsTeaserComponent {
  content = input.required<CmsTeaser | CmsMenuFoodItem>();
  headerLevel = input(DEFAULT_HEADER_LEVEL);
  showIcon = input<boolean>(false);

  private teaser = computed<CmsTeaser>(() => this.content() as CmsTeaser);

  title = computed<string>(() => this.teaser().teaserTitle);
  text = computed<string>(() => this.teaser().teaserText);
  image = computed<CmsImageData | undefined>(() => this.teaser().picture);
  subjectTaxonomyTags = computed<string[]>(() => this.teaser().subjectTaxonomyTags);
  icon = computed<string>(() => {
    const url = this.teaser().iconUrl;
    return this.showIcon() && isNotBlank(url) ? url : '';
  });
  sectionTestId = computed<string | null>(() => {
    const sectionId = toKebabCase(this.teaser()?.teaserTitle);
    return sectionId ? `section-${sectionId}` : null;
  });
  layoutVariant = computed<string>(() => (this.teaser().viewTypeName || 'section-two-thirds-right').split('--')[0]); // @todo: Split can be removed once the layoutvariant split into tags happens in core media. Also still need to fallback this in case of 'null'

  /**
   * @todo: Meal info shown as teaser is first additional content type here.
   * If more types are starting to clutter this component with specific fields,
   * refactor them all into own components.
   */
  ingredients = computed<string>(() => (this.content() as CmsMenuFoodItem).ingredients);

  isFullWidth = computed<boolean>(() => this.content()?.gridClass?.includes('grid-col-12') ?? false);
}
